module.exports = __webpack_public_path__ + "img/python.c2281c83.png";